import React from "react";
import {PaymentElement} from '@stripe/react-stripe-js';
import { useState } from "react";
import { register } from "../../services/api";
import { useNavigate } from "react-router-dom";

import {Elements,useStripe,useElements} from '@stripe/react-stripe-js';

const Checkout = (props)=>{
	const navigate = useNavigate();
	const [loader, setLoader] = useState(false);

	const elements = useElements();
	const stripe = useStripe(); 

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!stripe || !elements) {
			console.error('Stripe not loaded');
			return;
		}

		setLoader(true);

		try {
			// First, check the current state of the payment intent
			const { error: retrieveError, paymentIntent } = await stripe.retrievePaymentIntent(props.clientSecret);
			
			if (retrieveError) {
				console.error('Error retrieving payment intent:', retrieveError);
				if (props.setErrors) {
					props.setErrors({ payment: 'Payment setup failed. Please refresh and try again.' });
				}
				setLoader(false);
				return;
			}

			console.log('Payment Intent Status:', paymentIntent.status);

			// Handle different payment intent states
			if (paymentIntent.status === 'succeeded') {
				// Payment already succeeded, proceed with registration
				console.log('Payment already succeeded, proceeding with registration...');
				const response = await register(props.formData);
				console.log('Registration response (already succeeded):', response);
				console.log('Registration data (already succeeded):', response.data);
				
				if (response.data.token) {
					sessionStorage.setItem('token', response.data.token);
					sessionStorage.setItem('user_id', response.data.user.id);
					sessionStorage.setItem('user_name', response.data.user.name);
					sessionStorage.setItem('user_email', response.data.user.email);
					sessionStorage.setItem('user', JSON.stringify(response.data.user));
					navigate('/course/security-question');
				} else if (response.data.error === "User Already Exist") {
					// User already exists, redirect to login or show appropriate message
					if (props.setErrors) {
						props.setErrors({ registration: 'User already exists. Please login instead.' });
					}
					setLoader(false);
					// Optionally redirect to login after a delay
					setTimeout(() => {
						navigate('/login');
					}, 3000);
				} else if (response.data.error === "Invalid key supplied") {
					// Stripe key issue in backend
					if (props.setErrors) {
						props.setErrors({ registration: 'Payment processing error. Please contact support.' });
					}
					setLoader(false);
				} else {
					setLoader(false);
					if (props.setErrors) {
						props.setErrors({ registration: response.data.error || 'Registration failed. Please try again.' });
					}
				}
			} else if (paymentIntent.status === 'requires_payment_method' || paymentIntent.status === 'requires_confirmation') {
				// Payment needs to be confirmed
				console.log('Attempting to confirm payment...');
				const { error: confirmError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmPayment({
					elements,
					confirmParams: {
						return_url: `${window.location.origin}/course/home`,
					},
					redirect: "if_required",
					save_payment_method: false,
					
					
				});

				console.log('Payment confirmation result:', { confirmError, confirmedPaymentIntent });

				if (confirmError) {
					console.error('Payment confirmation failed:', confirmError);
					if (props.setErrors) {
						props.setErrors({ payment: confirmError.message || 'Payment failed. Please try again.' });
					}
					setLoader(false);
					return;
				}

				// Payment succeeded, proceed with registration
				if (confirmedPaymentIntent && confirmedPaymentIntent.status === 'succeeded') {
					console.log('Payment succeeded, proceeding with registration...');
					const response = await register(props.formData);
					console.log('Registration response:', response);
					console.log('Registration data:', response.data);
					
					if (response.data.token) {
						sessionStorage.setItem('token', response.data.token);
						sessionStorage.setItem('user_id', response.data.user.id);
						sessionStorage.setItem('user_name', response.data.user.first_name);
						sessionStorage.setItem('user_email', response.data.user.email);
						sessionStorage.setItem('user', JSON.stringify(response.data.user));
						navigate('/course/security-question');
					} else if (response.data.error === "User Already Exist") {
						// User already exists, redirect to login or show appropriate message
						if (props.setErrors) {
							props.setErrors({ registration: 'User already exists. Please login instead.' });
						}
						setLoader(false);
						// Optionally redirect to login after a delay
						setTimeout(() => {
							navigate('/login');
						}, 3000);
					} else if (response.data.error === "Invalid key supplied") {
						// Stripe key issue in backend
						if (props.setErrors) {
							props.setErrors({ registration: 'Payment processing error. Please contact support.' });
						}
						setLoader(false);
					} else {
						setLoader(false);
						if (props.setErrors) {
							props.setErrors({ registration: response.data.error || 'Registration failed. Please try again.' });
						}
					}
				} else {
					console.log('Payment not succeeded, status:', confirmedPaymentIntent?.status);
					setLoader(false);
				}
			} else {
				// Payment intent is in an unexpected state
				console.error('Unexpected payment intent status:', paymentIntent.status);
				if (props.setErrors) {
					props.setErrors({ payment: 'Payment is in an unexpected state. Please refresh and try again.' });
				}
				setLoader(false);
			}
		} catch (error) {
			console.error('Error during payment/registration:', error);
			setLoader(false);
			if (props.setErrors) {
				props.setErrors({ general: 'An error occurred. Please try again.' });
			}
		}
	};
	  
    	return(
		<>
		<PaymentElement options={{ wallets: { link: 'never' } }} />
		{loader?<span class=" mt-3 checkout-loader"></span>:<></>}
		<button 
			name="btn" 
			onClick={handleSubmit} 
			disabled={loader}
			class="btn btn-primary-s px-4 py-3 my-4 w-100 text-white"
		>
			{loader ? 'Processing...' : 'PAY'}
		</button>
		</>
	);
}
export default Checkout;
